import styled from "styled-components";

export const AlserkalAdvisoryWrapperDiv = styled.div`
  & .mobile {
    display: none !important;
  }
  & > h1 {
    color: var(--purple);
    font-size: 140px;
    font-family: var(--flexFont);
    margin: 0;
  }
  &.ak-background li:after{
    //background:none !important;
    background: linear-gradient(0deg,rgb(108 103 102),rgb(162 162 162));
  }
  &.ak-background li h4{
    color: #ffffff !important;
  }
  @media (max-width: 1023px) {
    --outerMargin: 50px;
  }
  @media (max-width: 767px) {
    --outerMargin: 25px;
    & .mobile {
      display: inline-block !important;
    }
    & .desktop {
      display: none !important;
    }
  }
`;

export const AlserkalAdvisoryWrapperInnerDiv = styled.div`
  max-width: var(--width);
  margin-left: auto;
  margin-right: auto;
  & > aside {
    margin-left: var(--outerMargin);
  }
`;

export const AlserkalAdvisoryWrapperWhiteDiv = styled.div`
  background-color: var(--white);
  padding-top: 50px;
  padding-bottom: 50px;
  & > div {
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
  }
`;
